import React, { FC, useContext } from "react";
import propTypes from "prop-types";

import { Payment } from "../../../../logic/api";

import flex from "../../../../styles/flex";
import styles from "./styles";

import { formatCurrency, paymentTypeLabelMap } from "../../../../utility/utils";
import { SessionContext, ISessionState } from "../../../../utility/useSession";
import { useDate } from "../../../../utility/useDate";
import { Trans, useTranslation } from "react-i18next";

interface IPaymentRecordProps {
    payment: Payment;
    session: ISessionState;
}

const PaymentRecord: FC<IPaymentRecordProps> = ({
    payment,
    session
}) => {
    const { toFormattedDateTimeString } = useDate();
    const { t } = useTranslation();
    const movementDate = toFormattedDateTimeString(new Date(payment.paymentDate));
    const amount = formatCurrency(payment.amount, session);
    const paymentType = paymentTypeLabelMap.get(payment.paymentType);
    const takenBy = `${payment.addedBy.firstName} ${payment.addedBy.lastName}`;

    let additionalFields = '';
    if (payment.authCode) {
        additionalFields = t("payments.authCode", { paymentAuthCode: payment.authCode });
    }

    if (payment.accountNumber) {
        additionalFields = t("payments.accountNumber", { paymentAccNumber: payment.accountNumber });
    }

    return (
        <div style={flex.flexRows}>
            <div style={flex.flexAuto}>
                <div style={styles.cell}>{movementDate}</div>
            </div>
            <div style={flex.flexFill}>
                <div style={styles.cell}>
                    <Trans
                        i18nKey="payments.paymentRecordedBy"
                        values={{
                            amount: `<b>${amount}</b>`,
                            paymentType: `<b>${paymentType}</b>`,
                            field: `<b>${additionalFields}</b>`,
                            takenBy: `<b>${takenBy}</b>`
                        }}
                        components={{
                            b: <b />
                        }}
                    />

                    {
                        (payment.description && payment.description.trim()) && (
                            <i style={{ marginLeft: 10, color: "gray" }}>{payment.description}</i>
                        )
                    }
                </div>
            </div>
        </div>
    )
}

interface IPaymentHistoryTableProps {
    payments: Payment[];
}

const PaymentHistoryTable: FC<IPaymentHistoryTableProps> = ({ payments = [] }) => {
    const session = useContext(SessionContext);
    const { t } = useTranslation();

    if (!session.current.site || !payments || !payments.length) {
        return <div>{t("input.validations.noPayment")}</div>
    }

    return (
        <div>
            {payments.map((p, i) => (
                <PaymentRecord
                    key={i}
                    payment={p}
                    session={session}
                />
            ))}
        </div>
    )
}

PaymentHistoryTable.propTypes = {
    payments: propTypes.any.isRequired
}

export default PaymentHistoryTable;
